"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkBlockTimesResponseToJSON = exports.NetworkBlockTimesResponseFromJSONTyped = exports.NetworkBlockTimesResponseFromJSON = void 0;
const _1 = require("./");
function NetworkBlockTimesResponseFromJSON(json) {
    return NetworkBlockTimesResponseFromJSONTyped(json, false);
}
exports.NetworkBlockTimesResponseFromJSON = NetworkBlockTimesResponseFromJSON;
function NetworkBlockTimesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mainnet': _1.NetworkBlockTimesResponseMainnetFromJSON(json['mainnet']),
        'testnet': _1.NetworkBlockTimesResponseMainnetFromJSON(json['testnet']),
    };
}
exports.NetworkBlockTimesResponseFromJSONTyped = NetworkBlockTimesResponseFromJSONTyped;
function NetworkBlockTimesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mainnet': _1.NetworkBlockTimesResponseMainnetToJSON(value.mainnet),
        'testnet': _1.NetworkBlockTimesResponseMainnetToJSON(value.testnet),
    };
}
exports.NetworkBlockTimesResponseToJSON = NetworkBlockTimesResponseToJSON;
//# sourceMappingURL=NetworkBlockTimesResponse.js.map